// transition/PageTransition.js
import { motion } from 'framer-motion';
import { Outlet } from 'react-router-dom';

/**
 * PageTransition
 *
 * The layout route around every page (App.js): a short fade between routes.
 *
 * It paints no background of its own. theme.css already paints the page on
 * html, body and #root -- var(--bg-page, var(--bg-primary)), so Classic
 * Light's gradient and every other theme's flat color -- and that surface runs
 * the full height of the document, footer included. A background here used to
 * cover it with a flat --bg-primary: in every other theme that repainted the
 * same color, but in Classic Light it hid the gradient behind every page and
 * left a visible edge where the page met the footer and the side gutters.
 */
const PageTransition = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: 'easeInOut' }}
      style={{ minHeight: '100vh' }}
    >
      <Outlet />
    </motion.div>
  );
};

export default PageTransition;